import { useQuery } from "@tanstack/react-query";
import { type AppSummary, listAppVersions } from "../../api/hub/apps";
import { AppMetadata, AppScope } from "./AppMetadata";
export function VersionPanel(
  { app, onClose, onRollback, busy }: {
    app: AppSummary;
    onClose: () => void;
    onRollback: (version: number) => void;
    busy: boolean;
  },
) {
  const versions = useQuery({
    queryKey: ["hub", "apps", "versions", app.id],
    queryFn: () => listAppVersions(app.id),
  });
  return (
    <aside className="apps-version-panel" aria-label="应用版本详情">
      <header>
        <h2>{app.name}</h2>
        <button onClick={onClose}>关闭版本</button>
      </header>
      <p>由 {app.ownerName} 发布</p>
      <div className="apps-detail-metadata">
        <AppMetadata app={app} />
        <AppScope app={app} />
      </div>
      <p className="apps-meta">
        回滚将恢复所选版本的内容及权限范围。共享应用只能回滚到已批准的精确版本；服务端再次核验。
      </p>
      {versions.isPending
        ? <p>正在读取版本…</p>
        : versions.error
        ? (
          <p role="alert">
            {versions.error.message}
            <button onClick={() => void versions.refetch()}>
              重新读取版本
            </button>
          </p>
        )
        : (
          <ol className="apps-timeline">
            {versions.data?.map((v) => (
              <li key={v.version}>
                <div>
                  <strong>第 {v.version} 版</strong>
                  <span>{new Date(v.createdAt).toLocaleString("zh-CN")}</span>
                  <code>{v.contentHash.slice(0, 12)}</code>
                </div>
                {v.version === app.privateCurrentVersion && <p>作者当前版本</p>}
                {v.version === app.sharedApprovedVersion && <p>全员批准版本</p>}
                <p>
                  可读：{v.manifest.tools.join("、") || "无业务数据"} · 外联：{[
                    ...v.manifest.csp.connectDomains,
                    ...v.manifest.csp.resourceDomains,
                  ].join("、") || "无"}{" "}
                  · 设备：{v.manifest.permissions.join("、") || "无"}
                </p>
                {v.scan.warnings.map((w, i) => (
                  <p key={i}>{w.line ? `第 ${w.line} 行：` : ""}{w.message}</p>
                ))}
                <button
                  disabled={busy}
                  onClick={() => onRollback(v.version)}
                >
                  {app.status === "disabled" ? "恢复到此版本" : "回滚到此版本"}
                </button>
              </li>
            ))}
          </ol>
        )}
    </aside>
  );
}
